// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-tabs {
  width: 100%;
}

.detail-tabs-bar {
  display: flex;
  align-items: stretch;
  gap: 4px;
  border-bottom: 1px solid #eaeff7;
  margin: 0 0 16px;
  padding: 0 4px;
  overflow-x: auto;
}

.detail-tab {
  position: relative;
  appearance: none;
  border: none;
  background: transparent;
  padding: 10px 14px 12px;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  font-weight: 500;
  color: #5f7484;
  cursor: pointer;
  white-space: nowrap;
  width: fit-content !important;
  transition: color 0.14s;
}

.detail-tab:hover {
  color: #0b1e2d;
}

.detail-tab.is-active {
  color: #00146d;
  font-weight: 700;
}

.detail-tab.is-active::after {
  content: '';
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: -1px;
  height: 2.5px;
  border-radius: 2px 2px 0 0;
  background: #00146d;
}

.detail-tabs-panel {
  width: 100%;
  padding: 0 2px 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/detail/detail-tabs.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".detail-tabs {\n  width: 100%;\n}\n\n.detail-tabs-bar {\n  display: flex;\n  align-items: stretch;\n  gap: 4px;\n  border-bottom: 1px solid #eaeff7;\n  margin: 0 0 16px;\n  padding: 0 4px;\n  overflow-x: auto;\n}\n\n.detail-tab {\n  position: relative;\n  appearance: none;\n  border: none;\n  background: transparent;\n  padding: 10px 14px 12px;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #5f7484;\n  cursor: pointer;\n  white-space: nowrap;\n  width: fit-content !important;\n  transition: color 0.14s;\n}\n\n.detail-tab:hover {\n  color: #0b1e2d;\n}\n\n.detail-tab.is-active {\n  color: #00146d;\n  font-weight: 700;\n}\n\n.detail-tab.is-active::after {\n  content: '';\n  position: absolute;\n  left: 10px;\n  right: 10px;\n  bottom: -1px;\n  height: 2.5px;\n  border-radius: 2px 2px 0 0;\n  background: #00146d;\n}\n\n.detail-tabs-panel {\n  width: 100%;\n  padding: 0 2px 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
